import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintloanapprovalService } from "../../../shared/print/printloanapproval.service";

@Component({
  selector: 'app-rptloanapprovalpopup',
  templateUrl: './rptloanapprovalpopup.component.html',
  styleUrls: ['./rptloanapprovalpopup.component.css']
})
export class RptloanapprovalpopupComponent implements OnInit {

  LoanTypeList: any[] = [];
  SchemeList: any[] = [];
  BranchList: any[] = [];
  CentreList: any[] = [];
  CategoryList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printloanapprovalService: PrintloanapprovalService,
    ) { }

  ngOnInit() {

    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    // this.GetCentre();
    this.GetCategory();

    this.data.SchemeId = 0;
    this.data.LoanTypeId = 0;
    this.data.LoanCategoryId = 0;
    this.data.CentreId = 0;
    this.data.BranchId = 0;
    this.data.StatusId = 0;
  }

  GenerateReports(): void {
    this.data.ReportName = "LoanApprovalReport";
    this.printloanapprovalService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetCategory() {
    this.CommonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
    })
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
      this.SelectCentre(this.data.BranchId)
    })
  }

  SelectCentre(branchId : any){
    this.CommonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
      this.CentreList = data;
    })

  }

}

